module.exports = __webpack_public_path__ + "img/Icon_Info.d5c5bb99.svg";